import { LargeTileCard } from "@/components/large-tile-card";
import SchematisationCataloguePlaceholder from "@/images/schematisation-catalogue-placeholder.svg?url";
import type { SchematisationWithId } from "@/queries/query-hcc-schematisation";

export const SCHEMATISATION_CARD_HEIGHT = 56;

export const SchematisationCard = ({
  schematisation,
  setSchematisation,
}: {
  schematisation: SchematisationWithId;
  setSchematisation: (schematisation: SchematisationWithId | undefined) => void;
}) => {
  return (
    <LargeTileCard
      title={schematisation.name}
      tags={schematisation.tags}
      height={SCHEMATISATION_CARD_HEIGHT}
      imageSrc={SchematisationCataloguePlaceholder}
      imageAlt={`schematisation ${schematisation.name}`}
      textAlign="center"
      onClick={() => setSchematisation(schematisation)}
    />
  );
};
